import React, { Component } from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import { Notification, translate, userLogin } from 'react-admin';
import { lightTheme } from './themes';
import ReactGA from 'react-ga';

var bg = require('../res/loginBG2.jpg');

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: 'url(' + bg + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: theme.palette.secondary.main,

    },
    card: {
        minWidth: 300,
        marginTop: '6em',
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.grey[500],
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = {},
    input: { ...inputProps },
    ...props
}) => (
        <TextField
            error={!!(touched && error)}
            helperText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
        />
    );

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            ADMINpassword:'',
            username: ''
        }
      }
    
    componentWillMount(){

    }
    
    componentDidMount() {
        sessionStorage.clear();
        //ReactGA.initialize('UA-155476865-1');
        //ReactGA.pageview(window.location.pathname + window.location.search);
        var username = this.getURLParameter('CRMuser');
        var password = this.getURLParameter('CRMpassword');
        var ymapitoken = this.getURLParameter('ymapitoken');
        if (username!=undefined && password!=undefined){
            this.props.userLogin({username,password});
        }
        const mfaDoneStatus = this.getURLParameter('mfaDoneStatus')
        if(ymapitoken){
            if((!mfaDoneStatus) || 
            (mfaDoneStatus === 'ALREADY_PASSED' || mfaDoneStatus === 'VALID')){
                this.props.userLogin({username,password,ymapitoken });
            }
        }
        if(['CLOSE', 'EXIT', 'ABORT', 'NO_HAVE_METHODS', 'API_INVALID_RESPONSE'].includes(mfaDoneStatus)){
            window.location = window.location.origin + window.location.pathname;
            return;
        }
    }

    getURLParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }

    login = ({ username, password }) => {
        console.log({ username, password });
        const { userLogin, location } = this.props;
        sessionStorage.setItem('ADMINpassword', this.state.ADMINpassword);
        userLogin({ username, password }, location.state ? location.state.nextPathname : '/');
    }

    handlePasswordChange = (e) => {
        let password = e.target.value;
        this.setState({ password: password });
    };
    handleADMINPasswordChange = (e) => {
        let ADMINpassword = e.target.value;
        this.setState({ ADMINpassword: ADMINpassword });
    };
    handleUsernameChange = (e) => {
        let username = e.target.value;
        this.setState({ username: username });
    };

    submitHandler(e) {
        e.preventDefault();
    }

    render() {
        const { classes, handleSubmit, isLoading, translate } = this.props;
        return (
            <div className={classes.main}>
                <Card className={classes.card}>
                    <div className={classes.avatar}>
                        <Avatar className={classes.icon}>
                            <LockIcon />
                        </Avatar>
                    </div>
                    <form onSubmit={handleSubmit(this.login)}>
                        <div className={classes.hint}>{translate('ra.auth.title')}</div>
                        <div className={classes.form}>
                            <div className={classes.input}>
                                <Field
                                    onChange={(e) => this.handleUsernameChange(e)}
                                    autoFocus
                                    name="username"
                                    component={renderInput}
                                    label={translate('ra.auth.username')}
                                    disabled={isLoading}
                                />
                            </div>
                            <div className={classes.input}>
                                <Field
                                    onChange={(e) => this.handlePasswordChange(e)}
                                    name="password"
                                    component={renderInput}
                                    label={translate('ra.auth.password')}
                                    type="password"
                                    disabled={isLoading}
                                />
                            </div>
                            <div className={classes.hint}>{translate('ra.auth.ADMINtitle')}</div>
                            <div className={classes.input}>
                                <Field
                                    onChange={(e) => this.handleADMINPasswordChange(e)}
                                    name="ADMINpassword"
                                    component={renderInput}
                                    label={translate('ra.auth.ADMINpassword')}
                                    type="password"
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                        <CardActions className={classes.actions}>
                            <Button
                                variant="raised"
                                type="submit"
                                color="primary"
                                disabled={isLoading}
                                className={classes.button}
                                fullWidth
                            >
                                {isLoading && (
                                    <CircularProgress size={25} thickness={2} />
                                )}
                                {translate('ra.auth.sign_in')}
                            </Button>
                        </CardActions>
                    </form>
                </Card>
                <Notification />
            </div>
        );
    }
}

Login.propTypes = {
    ...propTypes,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    previousRoute: PropTypes.string,
    translate: PropTypes.func.isRequired,
    userLogin: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.username) {
                errors.username = translate('ra.validation.required');
            }
            if (!values.password) {
                errors.password = translate('ra.validation.required');
            }
            return errors;
        },
    }),
    connect(
        mapStateToProps,
        { userLogin }
    ),
    withStyles(styles)
);

const EnhancedLogin = enhance(Login);

// We need to put the MuiThemeProvider decoration in another component
// Because otherwise the withStyles() HOC used in EnhancedLogin won't get
// the right theme
const LoginWithTheme = props => (
    <MuiThemeProvider theme={createMuiTheme(lightTheme)}>
        <EnhancedLogin {...props} />
    </MuiThemeProvider>
);

export default LoginWithTheme;